// Loads the Spotfire Web Player JavaScript API (oauth.js) and opens an analysis
// using the OAuth 2.0 Authorization Code + PKCE flow (Spotfire 15.0 JS API).

const OAUTH_CLIENT_ID =
    "bcd4defb82ea80ad9a633eaa91e926aa.oauth-clients.spotfire.com";
const OAUTH_JS_PATH = "/spotfire/js-api/oauth.js";
const REDIRECT_PATH = "/spotfire-oauth-end.html";
const API_VERSION = "15.0";

let scriptPromise = null;
// setApiVersion may only be called once per page load.
let apiVersionSet = false;

const loadSpotfireApi = (server) => {
    if (window.spotfire?.webPlayer) {
        return Promise.resolve(window.spotfire.webPlayer);
    }
    if (scriptPromise) {
        return scriptPromise;
    }

    scriptPromise = new Promise((resolve, reject) => {
        const src = `${server}${OAUTH_JS_PATH}`;
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => {
            if (window.spotfire?.webPlayer) {
                resolve(window.spotfire.webPlayer);
            } else {
                scriptPromise = null;
                reject(new Error("Spotfire Web Player API failed to initialize"));
            }
        };
        script.onerror = () => {
            scriptPromise = null;
            reject(new Error("Failed to load Spotfire oauth.js"));
        };
        document.head.appendChild(script);
    });

    return scriptPromise;
};

// Normalizes a template detail link into a Spotfire library analysis path.
// e.g. "./Suppliers/Zollner/Analysis" -> "/Suppliers/Zollner/Analysis"
export const getAnalysisPath = (detailLink) => {
    if (!detailLink) {
        return "";
    }
    let path = detailLink.trim();
    if (path.startsWith(".")) {
        path = path.slice(1);
    }
    if (!path.startsWith("/")) {
        path = `/${path}`;
    }
    return path;
};

export const openSpotfireAnalysis = async ({ server, path, elementId }) => {
    const webPlayer = await loadSpotfireApi(server);

    if (!apiVersionSet) {
        webPlayer.setApiVersion(API_VERSION);
        apiVersionSet = true;
    }

    const redirectUri = `${window.location.origin}${REDIRECT_PATH}`;
    const token = await webPlayer.authenticate({
        clientId: OAUTH_CLIENT_ID,
        server,
        redirectUri,
    });

    const app = await webPlayer.connect({ token, path });
    const document = app.openDocument(elementId);
    return { app, document };
};
